import { n as l } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const n = {
  name: "CheckIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var r = function() {
  var t = this, e = t._self._c;
  return e("span", t._b({ staticClass: "material-design-icon check-icon", attrs: { "aria-hidden": t.title ? null : !0, "aria-label": t.title, role: "img" }, on: { click: function(i) {
    return t.$emit("click", i);
  } } }, "span", t.$attrs, !1), [e("svg", { staticClass: "material-design-icon__svg", attrs: { fill: t.fillColor, width: t.size, height: t.size, viewBox: "0 0 24 24" } }, [e("path", { attrs: { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" } }, [t.title ? e("title", [t._v(t._s(t.title))]) : t._e()])])]);
}, s = [], a = /* @__PURE__ */ l(
  n,
  r,
  s,
  !1,
  null,
  null,
  null,
  null
);
const _ = a.exports;
export {
  _ as C
};
